/* tslint:disable */
/* eslint-disable */
/**
 * Your Project API
 * Your project description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectClient
 */
export interface ProjectClient {
    /**
     * 
     * @type {number}
     * @memberof ProjectClient
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectClient
     */
    readonly name: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectClient
     */
    readonly description: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectClient
     */
    readonly image: string;
}

export function ProjectClientFromJSON(json: any): ProjectClient {
    return ProjectClientFromJSONTyped(json, false);
}

export function ProjectClientFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectClient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'image': json['image'],
    };
}

export function ProjectClientToJSON(value?: ProjectClient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

